// import React from "react";
import "./home.css";
import "./animation.css";
import circuit from "./circuit.json";
import system from "./system.json";
import logoAnim from "./animation_logo.json";
// import { ReactComponent as Polygon4 } from "./Polygon4.svg";
import { useEffect, useState } from "react";
import Lottie from "lottie-web";
import ProfileCard from "../../Components/Home-Components/ProfileCard/ProfileCard";
import FaqAccordion from "../../Components/Home-Components/FaqAccordion";
import ProfileSwitch from "../../Components/Home-Components/FaqProfileSwitch";
import { NavbarComp } from "../../Components/Authentications-Components/Navbar";

function Home() {
  const profiles = [
    { id: 1, name: "Algos", src: "./Algos.svg" },
    { id: 2, name: "Application Dev", src: "./AppDev.svg " },
    { id: 3, name: "DevOps", src: "./DevOps.svg" },
    { id: 4, name: "EE", src: "./EE.svg" },
    { id: 5, name: "Robotics", src: "./Robot.svg" },
    { id: 6, name: "ML", src: "./ML.svg" },
    { id: 7, name: "Cybersecurity", src: "./Cybersecurity.svg" },
    { id: 8, name: "UI/UX", src: "./Networks.svg" },
    { id: 9, name: "Blockchain", src: "./Blockchain.svg" },
  ];
  useEffect(() => {
    Lottie.loadAnimation({
      container: document.querySelector("#circuit"),
      animationData: circuit,
      renderer: "svg",
      loop: true,
      autoplay: true,
    });
    Lottie.loadAnimation({
      container: document.querySelector("#system"),
      animationData: system,
      renderer: "svg",
      loop: true,
      autoplay: true,
    });
    Lottie.loadAnimation({
      container: document.querySelector("#logo_home"),
      animationData: logoAnim,
      renderer: "svg",
      loop: false,
      autoplay: true,
    });
  }, []);
  const [curProfile, setCurProfile] = useState(0);
  return (
    <div className="homeContainer">
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
      <NavbarComp />
      <div id="gif-container">
        <div id="logo_home" />
        <button
          onClick={() => {
            window.open("https://spider.nitt.edu", "_blank");
          }}
          className="link-button"
        >
          GO TO SITE
        </button>
      </div>
      <div id="about">
        <div className="aboutContainer">
          <h1>Spider R&amp;D Club</h1>
          <div className="grad-underline"></div>
          <div id="about-text">
            <p>
              SPIDER, the Research and Development Club of NIT Trichy is a group
              of people enthusiastic about technology and innovation. We ideate
              and pursue projects that are relevant to today&apos;s industry in
              fields like Artificial Intelligence and Machine Learning,
              Electronics, Computer Technology along with App and Web
              Development. We are the multi-disciplinary club of our college. We
              as a team look forward to Ideate and Innovate to take Research and
              Development projects to greater heights. Interested to delve deep
              into these? Grab this opportunity to get your hands dirty and join
              a team of tech enthusiasts!!!
            </p>
          </div>
          {/* <div>
            <button id="registerBtn">REGISTER</button>
            <button id="loginBtn">LOGIN</button>
          </div> */}
        </div>

        <div id="circuit" />
        <div className="polygon4-container">
          <img src="./Polygon4.svg" alt="polygon4" id="polygon4Img" />
        </div>
      </div>
      <div className="profile-container" id="profiles">
        <h1>PROFILES</h1>
        <div className="grad-underline underline-profile"></div>
        <div className="profile-wrapper">
          <div className="profile-cards-container">
            {profiles.map((profile) => (
              <ProfileCard
                key={profile.id}
                id={profile.id}
                profile={profile.name}
                imgSrc={profile.src}
              />
            ))}
          </div>
        </div>
      </div>
      {/* <div className="system-container">
        <div id="system" />
        <img src="./Polygon5.svg" alt="" id="polygon5" />
      </div> */}
      <div className="faq-container" id="faq">
        <div style={{ zIndex: 5 }}>
          <h1>FAQs</h1>
          <div className="grad-underline underline-faq"></div>
        </div>
        {/* Toggle between profiles */}
        <ProfileSwitch curProfile={curProfile} setCurProfile={setCurProfile} />

        <FaqAccordion curProfile={curProfile} />
      </div>
      <div className="footer-container">
        <div className={`footer-gradline grad-underline`}></div>
        <h3 style={{ textAlign: "center", color: "#fff" }}>
          Weaved with 🕸 by{" "}
          <a
            href="https://spider.nitt.edu/"
            rel="noopener noreferrer"
            target="_blank"
            style={{ textDecoration: "none", color: "white" }}
          >
            Spider
          </a>
        </h3>
        <div style={{ margin: "auto" }}>
          <a
            href="https://www.facebook.com/SpiderNitt/"
            rel="noopener noreferrer"
            target="_blank"
            style={{ fontFamily: "Font Awesome 6 Brands" }}
            className="fa fa-facebook"
          >
            {""}
          </a>
          <a
            href="https://www.instagram.com/spider_nitt/"
            rel="noopener noreferrer"
            target="_blank"
            style={{ fontFamily: "Font Awesome 6 Brands" }}
            className="fa fa-instagram"
          >
            {""}
          </a>
          <a
            href="https://www.linkedin.com/company/spider-r-d/"
            rel="noopener noreferrer"
            target="_blank"
            style={{ fontFamily: "Font Awesome 6 Brands" }}
            className="fa fa-linkedin"
          >
            {""}
          </a>
          <a
            href="https://medium.com/spidernitt"
            rel="noopener noreferrer"
            target="_blank"
            style={{ fontFamily: "Font Awesome 6 Brands" }}
            className="fa fa-medium"
          >
            {""}
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;
